import { c as _c } from "react/compiler-runtime";
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';
function useAdultContentRedirection() {
  const $ = _c(9);
  const router = useRouter();
  const {
    isAdult,
    siteMode
  } = useGetLoginInfoQuery();
  const playInfo = useFetchLivePlayMutationStore(_temp);
  let t0;
  if ($[0] !== isAdult || $[1] !== playInfo || $[2] !== router || $[3] !== siteMode) {
    t0 = () => {
      if (!siteMode || !playInfo?.media) {
        return;
      }
      const isSLMode = new URLSearchParams(window.location.search).get("sl") === "1";
      if (isSLMode) {
        return;
      }
      const isAdultContent = playInfo.media.isAdult;
      if (["w", "c"].includes(siteMode.mode) && isAdultContent && !isAdult) {
        router.replace("/");
      }
    };
    $[0] = isAdult;
    $[1] = playInfo;
    $[2] = router;
    $[3] = siteMode;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== isAdult || $[6] !== playInfo || $[7] !== siteMode) {
    t1 = [playInfo, isAdult, siteMode];
    $[5] = isAdult;
    $[6] = playInfo;
    $[7] = siteMode;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  useEffect(t0, t1);
}
function _temp(state) {
  return state.data;
}
export default useAdultContentRedirection;